import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
// hooks
import { useRisksAPI } from 'hooks/risks/useRiskAPI'
// components
import PageLoader from 'components/UI/Loader/PageLoader'

const RiskCreatePage: React.FC = () => {
  const router = useRouter()

  const { createRisk } = useRisksAPI()

  const templateId = router.query.id as string

  const onRiskCreate = async () => {
    const { id } = await createRisk({
      riskTemplateId: templateId
    })

    router.push(`/forms/edit/${id}/template/${templateId}`)
  }

  React.useEffect(() => {
    if (templateId) {
      onRiskCreate()
    }
  }, [templateId])

  return <PageLoader isLoading />
}

export default RiskCreatePage
